/// <amd-module name="Build/SourceProviders/GitHubEnterprise" />
import { BaseGit } from "Build/SourceProviders/BaseGit";
import { IBranchInfo, ICommitInfo, IRepositoryInfo, RepositoryTypes } from "Build/SourceProviders/Common";
import { ExternalUnknown } from "Build/SourceProviders/ExternalUnknown";
import * as Resources from "Build/SourceProviders/Resources";
import { IVCNavigationService } from "VC/Common/Navigation";
import { IVssPageContext } from "VSS/Platform/Context";

export class GitHubEnterprise extends BaseGit {
    private _externalRepo: ExternalUnknown;

    public constructor(pageContext: IVssPageContext) {
        super(pageContext);
        this._externalRepo = new ExternalUnknown(pageContext);
    }

    public getKey(): string {
        return RepositoryTypes.GitHubEnterprise;
    }

    public getName() {
        return Resources.GitHubEnterprise;
    }

    public fetchBranchLink(info: IBranchInfo): Promise<string | null> {
        return this._externalRepo.fetchBranchLink(info);
    }

    public fetchCommitLink(info: ICommitInfo): Promise<string | null> {
        return this._externalRepo.fetchCommitLink(info);
    }

    public fetchRepositoryLink(info: IRepositoryInfo, projectName?: string): Promise<string | null> {
        return Promise.resolve(this._getRepoUrl(info.repositoryUrl));
    }

    protected _getBranchLink(info: IBranchInfo, service: IVCNavigationService): string {
        const url = this._getRepoUrl(info.repositoryUrl);
        if (url && info.branchName) {
            const normalizedBranchName = this._normalizeBranchName(info.branchName);
            return `${url}/tree/${normalizedBranchName}`;
        }
        return this._externalRepo.getBranchLink(info);
    }

    protected _getRepositoryLink(info: IRepositoryInfo, service: IVCNavigationService): string {
        return this._getRepoUrl(info.repositoryUrl);
    }

    protected _getCommitLink(info: ICommitInfo, service: IVCNavigationService): string {
        return this._externalRepo.getCommitLink(info);
    }

    public getRepoIconName(): string {
        return "GitHubLogo";
    }

    public getMaxWorkItems(): number | undefined {
        return 10;
    }

    private _getRepoUrl(url?: string): string {
        if (!url) {
            return "";
        }
        if (url.endsWith(".git")) {
            return url.slice(0, url.length - 4);
        }
        return url;
    }
}
